import React from 'react';
import { StarIcon, ShieldCheckIcon, BellIcon, SearchIcon, TagIcon } from 'lucide-react';
const benefits = [{
  title: 'Early Service Preview',
  description: 'Get a first look at available services before the public launch.',
  icon: StarIcon
}, {
  title: 'Priority Onboarding',
  description: 'Early access requests may receive priority review when onboarding begins.',
  icon: ShieldCheckIcon
}, {
  title: 'Launch Notifications',
  description: 'Receive updates when BizCloudDesk is ready to accept new customers.',
  icon: BellIcon
}, {
  title: 'Service Fit Review',
  description: 'Let us know what your business needs so we can recommend the right setup.',
  icon: SearchIcon
}, {
  title: 'Possible Early Access Offer',
  description: 'Early users may receive introductory pricing, setup assistance, or bundled service options when available.',
  icon: TagIcon
}];
export function WhyJoinEarly() {
  return <section className="py-24 bg-white" data-id="element-237">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-238">
        <div className="text-center mb-16" data-id="element-239">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-240">
            Why Request Early Access?
          </h2>
          <p className="text-slate-600" data-id="element-241">
            Join the waitlist and gain exclusive advantages before our August
            2026 launch.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-242">
          {benefits.map((benefit, index) => <div key={index} className="flex gap-6 p-6 rounded-2xl border border-slate-50 bg-slate-50/30" data-id="element-243">
              <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-244">
                <benefit.icon className="w-6 h-6 text-blue-600" data-id="element-245" />
              </div>
              <div data-id="element-246">
                <h3 className="font-bold text-slate-900 mb-2" data-id="element-247">
                  {benefit.title}
                </h3>
                <p className="text-sm text-slate-600 leading-relaxed" data-id="element-248">
                  {benefit.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}